import { createContext } from "react";
import { NamingFrameWork } from "src/models/model";

interface NamingFrameworkType {
    namingFramework: NamingFrameWork,
    setNamingFrameWorkData: () => void;
}

export const NamingFrameworkContext = createContext<NamingFrameworkType>(null);
